import { Navbar } from "@/components/site/Navbar";
import { scrollToTarget } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { About } from "@/components/site/About";
import { Showcase } from "@/components/site/Showcase";
import { Services } from "@/components/site/Services";
import { Testimonials } from "@/components/site/Testimonials";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { ArrowRight } from "lucide-react";

export default function Home() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const target = location.state?.scrollTarget;
    if (!target) return;
    window.history.replaceState({}, "");
    let count = 0;
    let timer;
    const attempt = () => {
      scrollToTarget(target);
      count += 1;
      if (count < 5) timer = setTimeout(attempt, 450);
    };
    timer = setTimeout(attempt, 350);
    return () => clearTimeout(timer);
  }, [location.state]);

  return (
    <main data-testid="home-page" className="relative">
      <Navbar />
      <Hero />
      <div className="bg-[var(--ink)] px-5 lg:px-14 pt-3 pb-4 lg:pt-12 lg:pb-6">
        <div className="mx-auto flex max-w-[1860px] items-end justify-between gap-6">
          <h2
            data-testid="our-services-title"
            className="font-title text-3xl sm:text-6xl lg:text-7xl text-white leading-none"
          >
            Our Services
          </h2>
          <button
            onClick={() => navigate("/services")}
            data-testid="view-all-services-link"
            className="group inline-flex shrink-0 items-center gap-1.5 sm:gap-3 pb-2 font-body text-[0.6rem] sm:text-sm font-medium uppercase tracking-[0.12em] sm:tracking-[0.24em] text-[var(--foam)]/85 transition-colors duration-300 hover:text-[var(--aqua)]"
          >
            View All Services
            <ArrowRight className="h-3 w-3 sm:h-4 sm:w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </button>
        </div>
      </div>
      <About />
      <div
        data-testid="ocean-bg-wrapper"
        className="relative bg-cover bg-top bg-no-repeat"
        style={{ backgroundImage: "url('/media/ocean-bg.jpg')" }}
      >
        <Showcase />
        <Services />
        <Testimonials />
        <Contact />
        <Footer />
      </div>
    </main>
  );
}
